import React from "react";
import "./index.scss";
import i18n from "./localization/i18nPolicyholder";
import {RouterProvider} from "react-router-dom";
import {Provider} from "react-redux";
import {route} from "./utils/route";
import {ThemeProvider} from "@mui/material/styles";
import theme from "./utils/theme";
import {I18nextProvider} from "react-i18next";
import {client, store} from "./store/store";
import {ApolloProvider} from "@apollo/client";
import ErrorBoundary from "./ErrorBoundary";
import Loader from "./components/Loader";
import FetchUser from "./reusableComponents/components/generics/FetchUser";

const App = () => (
  <>
    <ErrorBoundary>
      <Provider store={store}>
        <ThemeProvider theme={theme}>
          <I18nextProvider i18n={i18n}>
            <ApolloProvider client={client}>
              <Loader/>
              <FetchUser/>
              <RouterProvider router={route}/>
            </ApolloProvider>
          </I18nextProvider>
        </ThemeProvider>
      </Provider>
    </ErrorBoundary>
  </>
);
export default App;